/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Flex, Image } from '@chakra-ui/react'
import '@xyflow/react/dist/style.css'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import LoadingContainer from '../../../../components/LoadingContainer'
import { CreateColaboradorModal } from '../../../../components/ModalCreateColaborador'
import { SelectCmp } from '../../../../components/SelectCmp'
import { SwitchCmp } from '../../../../components/SwitchCmp'
import { useAuth } from '../../../../contexts/AuthContext'
import { IDepartment, iPerfilColaborador, iPostColaborador, ISquad, iStatusOrganograma } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'
import { parseJwt } from '../../../../services/token'
import { EhTellescom, OcultarCargoParaNaoAdm } from '../../../../Utils/Helper'
import { CountBar } from '../Components/CountBar'
import { NavBar } from '../Components/NavBar'
import { ModalCores } from './Components/ModalCores'
import BasicFlow from './Components/ReactFlow/Flow'
import { squadsParaOrganograma } from './Components/ReactFlow/squadsParaOrganograma'
import { SquadOrgChart } from './Components/SquadOrgChart'
import { Main, StyledButton } from './styles'

interface INavLink {
  to: string
  linkTitle: string
  exact?: boolean
}
interface IModel {
  departamentos: IDepartment[]
  organograma: IDepartment[]
}
export const DashboardDesenvolvimento: React.FC = () => {
  const { permitirFuncao } = useAuth()
  const nav = useNavigate()
  function ObterRotas(): INavLink[] {
    const rotas: INavLink[] = []
    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'visao-geral')) {
      rotas.push({
        to: '/Organograma/Dashboard',
        linkTitle: 'Visão geral'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'areas')) {
      rotas.push({
        to: '/Organograma/Departamentos',
        linkTitle: 'Áreas'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'funcoes')) {
      rotas.push({
        to: '/Organograma/Cargos',
        linkTitle: 'Cargos'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'squads')) {
      rotas.push({
        to: '/Organograma/Squads',
        linkTitle: 'Squads'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'colaboradores')) {
      rotas.push({
        to: '/Organograma/Colaboradores',
        linkTitle: 'Colaboradores'
      })
    }
    return rotas
  }
  const [Status, setStatus] = useState<iStatusOrganograma>()
  const [Colaborador, setColaborador] = useState<iPerfilColaborador>()
  const [Squads, setSquads] = useState<ISquad[]>([])
  const [Cores, setCores] = useState<string[]>([])
  const [View, setView] = useState(0)
  const [SquadEmFluxo, setSquadEmFluxo] = useState(EhTellescom())
  const [IsLoading, setIsLoading] = useState(false)
  const [ModalCoresIsOpen, setModalCoresIsOpen] = useState(false)
  const [ModalCreateIsOpen, setModalCreateIsOpen] = useState(false)
  const [listaTodosDepartamentos, setListaTodosDepartamentos] = useState<IModel>({ departamentos: [], organograma: [] })
  const [OrganogramaCompleto, setOrganogramaCompleto] = useState<IDepartment[]>([])
  const [depId, setDepId] = useState<string>('todos')
  const [OrganogramaPorFuncao, setOrganogramaPorFuncao] = useState<IDepartment[]>()
  const [IsLoadingFuncao, setIsLoadingFuncao] = useState(false)
  const OrganogramaPorSquad = useMemo(() => squadsParaOrganograma(Squads, !EhTellescom()), [Squads])

  function getStatus(): void {
    appApi.get('Organograma/ObterStatus')
      .then(res => setStatus(res.data))
      .catch(err => console.log(err))
  }

  function OnGetCores(): void {
    appApi.get('Empresa/Cores')
      .then(res => setCores(res.data))
      .catch(err => console.log(err))
  }

  function onUpdateCores(cores: string[]): void {
    appApi.put('Empresa/Cores', { cores: cores })
      .then(res => OnGetCores())
      .catch(err => console.log(err))
  }

  function getOrganograma(depId?: string): void {
    setIsLoading(true)
    appApi.get(`Departamento/Populado?depId=${depId ?? ''}`)
      .then(res => {
        setListaTodosDepartamentos(res.data)
        setOrganogramaCompleto(res.data.organograma)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function getSquads(): void {
    appApi.get('Organograma/VisualizarSquads')
      .then(res => setSquads(res.data))
      .catch(err => console.log(err))
  }
  function getOrganogramaPorFuncao(): void {
    setIsLoadingFuncao(true)
    appApi.get('Organograma/VisualizarPorFuncao')
      .then(res => setOrganogramaPorFuncao(res.data))
      .catch(err => console.log(err))
      .finally(() => setIsLoadingFuncao(false))
  }

  function getColaborador(): void {
    appApi.get('Colaborador/Perfil')
      .then(res => setColaborador(res.data))
      .catch(err => console.log(err))
  }

  // function onOpenModalCreate(id: string): void {
  //   setModalCreateIsOpen(true)
  //   setDemografiaId(id)
  // }

  function onCreateColaborador(form: iPostColaborador): void {
    appApi.post('Colaborador', form).then(res => {
      setModalCreateIsOpen(false)
      if (Colaborador?.id) {
        getOrganograma()
      }
    }).catch(err => console.log(err))
  }

  useEffect(() => {
    getStatus()
    getSquads()
    getColaborador()
    OnGetCores()
  }, [])

  useEffect(() => {
    if (Colaborador?.id) {
      getOrganograma()
    }
  }, [Colaborador])

  function listaTodosDeps(depId?: string): void {
    if (depId) {
      getOrganograma(depId)
    } else {
      getOrganograma()
    }
  }

  // function returnOrganograma(): any {
  //   const result = <Flex flexDir={'column'} mt={'8rem'} gap={'2.5rem'} className='center'>
  //           {listaTodosDepartamentos.organograma.map(e => {
  //             return (
  //               <Tree label={<Text bg={'var(--DegradeAzul)'} mx={'auto'} width={'fit-content'} color={'var(--c1)'} p={'.5rem 2rem'} borderRadius={'.25rem'} fontWeight={'700'} fontSize={'14px'}>{e.nome}</Text>} lineColor='var(--Azul)' lineWidth='2px' nodePadding='.5rem'>
  //                 {returnRamosOrganograma(e, true)}
  //               </Tree>
  //             )
  //           })}
  //         </Flex>
  //   return result
  // }

  // function returnRamosOrganograma(e: IDepartment, first: boolean): any {
  //   const result = <TreeNode label={<Flex flexDir={'column'} boxShadow={'var(--SombraBackground)'} border={'1px solid var(--Azul)'} p={'.75rem 2rem'} bg={'var(--c1)'} w={'fit-content'} alignItems={'center'}>
  //     <Flex w={'full'} gap={'2rem'} justifyContent={'space-between'}>
  //       <div></div>
  //       {!first && <Text bg={'var(--DegradeAzul)'} width={'fit-content'} color={'var(--c1)'} p={'.5rem 1.325rem'} borderRadius={'0 0 .5rem .5rem'} fontWeight={'800'} fontSize={'.875rem'} mb={'1rem'}>{e.nome}</Text>}
  //       <BsPersonPlus size={26} color='Rosa' cursor={'pointer'} onClick={() => setModalCreateIsOpen(true)}/>
  //     </Flex>
  //     <Flex gap={'.5rem'} justifyContent={'center'} py={'1rem'}>
  //       {e.colaboradores && e.colaboradores?.map(employee => {
  //         return (<Flex flexDir={'column'} alignItems={'center'}>
  //           <Container onClick={() => nav(`/Rh/VisualizarPerfil/${employee.id}`)}>
  //             <Content>
  //               <Flex justifyContent={'center'} height={'7.5rem'} w={'full'}>
  //                 <Img w={'full'} h={'full'} objectFit={'cover'} src={employee.avatar || 'https://sigah.blob.core.windows.net/onboard/da193183-666b-42cd-ae52-da86bc76f065.png'}/>
  //               </Flex>
  //               <div className='boxAzul'>
  //                 <p>{employee.nome}</p>
  //                 <p>{employee.sobrenome}</p>
  //               </div>
  //             </Content>
  //           </Container>
  //           <Flex mt={'.5rem'}>
  //             {employee.subordinados && employee.subordinados.map(a => {
  //               return (gerarSubordinados(a))
  //             })}
  //           </Flex>
  //         </Flex>)
  //       })}
  //     </Flex>
  //   </Flex>}>
  //       {e.departamentoFilhos && e.departamentoFilhos.map(deps => {
  //         return (
  //           returnRamosOrganograma(deps, false)
  //         )
  //       })}
  //   </TreeNode>

  //   return result
  // }

  // function gerarSubordinados(employee: IEmployee): any {
  //   const result = <TreeNode label={<Flex flexDir={'column'} alignItems={'center'}>
  //     <Container onClick={() => nav(`/Rh/VisualizarPerfil/${employee.id}`)}>
  //       <Content>
  //         <Flex justifyContent={'center'} height={'8.5rem'} w={'full'}>
  //           <Img w={'full'} h={'full'} objectFit={'cover'} src={employee.avatar || 'https://sigah.blob.core.windows.net/onboard/da193183-666b-42cd-ae52-da86bc76f065.png'}/>
  //         </Flex>
  //         <div className='boxAzul'>
  //           <p>{employee.nome}</p>
  //           <p>{employee.sobrenome}</p>
  //         </div>
  //       </Content>
  //     </Container>
  //     <Flex mt={'.5rem'}>
  //       {employee.subordinados && employee.subordinados.map(a => {
  //         return (gerarSubordinados(a))
  //       })}
  //     </Flex></Flex>}>
  //   </TreeNode>

  //   return result
  // }

  useEffect(() => {
    if (View === 2 && !OrganogramaPorFuncao) {
      getOrganogramaPorFuncao()
    }
  }, [View])

  useEffect(() => {
    if (depId !== 'todos') {
      listaTodosDeps(depId)
    } else {
      listaTodosDeps()
    }
  }, [depId])

  return (
    <Flex my={'2rem'}>
      <Main>
        {
          (ModalCreateIsOpen) && (
            <CreateColaboradorModal
              isOpen={ModalCreateIsOpen}
              onCreateEmployee={onCreateColaborador}
              onRequestClose={() => setModalCreateIsOpen(false)}
            />
          )
        }
        <ModalCores
          cores={Cores}
          isOpen={ModalCoresIsOpen}
          onRequestClose={() => setModalCoresIsOpen(false)}
          onUpdate={(cores) => onUpdateCores(cores)}
        />
        <NavBar
          title="Organograma"
          navLinks={ObterRotas()}
        />

        {!OcultarCargoParaNaoAdm() && (
          <CountBar
            countItems={[
              {
                value: Status?.colaboradores ?? 0,
                title: 'Colaboradores'
              },
              {
                value: Status?.cargos ?? 0,
                title: 'Funções'
              },
              {
                value: Status?.departamentos ?? 0,
                title: 'Áreas'
              }
            ]}
          />
        )}

        <main>
          <Flex marginBottom={'1rem'} alignItems={'end'} justifyContent={'space-between'} flexDir={'row'} marginLeft={'2rem'} marginRight={'2rem'}>
            <Flex gap={'1rem'}>
              { listaTodosDepartamentos.departamentos.length > 1 && View === 0 && (<SelectCmp value={depId} OnChange={(e) => setDepId(e) }>
                { listaTodosDepartamentos.departamentos.length !== 1 && <option value='todos'>Todos</option> }
                { listaTodosDepartamentos.departamentos.sort((a, b) => { return a.nome.localeCompare(b.nome) }).map((e) => {
                  return (
                    <option value={e.id}>{e.nome}</option>
                  )
                })}
              </SelectCmp>)}
              {View === 1 && !EhTellescom() && <SwitchCmp value={SquadEmFluxo} OnChange={setSquadEmFluxo} legendaEsquerda='Padrão' legendaDireita='Fluxograma' />}
              {parseJwt().adm === 'True' && <ButtonCmp onClick={() => setModalCoresIsOpen(true)} VarColor={'Green2'}>Mudar cores por nível</ButtonCmp>}
            </Flex>
            <Flex flexDir={'column'}>
              <strong>Tipo de visualização</strong>
              <Flex marginTop={'.5rem'} gap={'.75rem'}>
                <StyledButton onClick={() => { setView(0) }} selected={View === 0}>Matricial</StyledButton>
                {!OcultarCargoParaNaoAdm() && <StyledButton onClick={() => setView(1)} selected={View === 1}>Squad</StyledButton>}
                {!OcultarCargoParaNaoAdm() && <StyledButton onClick={() => setView(2)} selected={View === 2}>Função</StyledButton>}
              </Flex>
            </Flex>
          </Flex>

          {(!!Squads.length && View === 1 && !SquadEmFluxo) && (
            <SquadOrgChart reload={getSquads} squads={Squads} />
          )}

          {
            (!Squads.some(e => e.colaboradores?.length > 0) && View === 1) && (
              <Flex alignItems={'center'} color={'var(--Azul)'} justifyContent={'center'}>
                <Image className='sah_Img' height={'20rem'} src='https://sigah.blob.core.windows.net/assets/NovaSAH.png' />
                <h3>Ainda não há nenhum colaborador atribuído a um Squad...</h3>
              </Flex>
            )
          }
          {View === 1 && SquadEmFluxo && OrganogramaPorSquad.length > 0 && <BasicFlow departamentos={OrganogramaPorSquad} cores={Cores} endpoint='OrganogramaSquadNode' ordenavel/>}
          {View === 2 && IsLoadingFuncao && <LoadingContainer linhas={24} loading></LoadingContainer>}
          {View === 2 && !IsLoadingFuncao && <BasicFlow departamentos={OrganogramaPorFuncao ?? []} cores={Cores} layoutPersistido={false}/>}
          {View !== 2 && !(View === 1 && SquadEmFluxo) && IsLoading && <LoadingContainer linhas={24} loading></LoadingContainer>}
          {View !== 2 && !(View === 1 && SquadEmFluxo) && !IsLoading && <BasicFlow departamentos={listaTodosDepartamentos.organograma.length === 0 ? listaTodosDepartamentos.departamentos : listaTodosDepartamentos.organograma} cores={Cores} podeEditarLigacoes={parseJwt().adm === 'True' && View === 0 && depId === 'todos'} aoSalvarHierarquia={() => getOrganograma()}/>}
        </main>
      </Main>
    </Flex>
  )
}
